import { css } from "@linaria/core";
import { units } from "../css-tokens/units";

export const textColumnCls = css`
  margin: 0 auto;
  max-width: ${units.px(700)};
`;
